//crypto-js
import axios from "axios";
import storage from "../../utils/storage/cryptoStorage";
import { axiosInstance } from "../config/axiosInstance";


const authService = {
  login: async (
    username: string,
    password: string,
    officeId: number,
    turnstileToken: string
  ) => {
    try {
      var response = await axios.post(
        //"https://localhost:6101/api/auth/login",
         process.env.REACT_APP_API_URL + "/auth/api/Auth/login",
        {
          uname: username,
          password: password,
          officeid: officeId,
          turnstiletoken: turnstileToken,
          /*
          applicationId: 1,
          ipAdress: "string",
          macAdress: "123124",
          */
        }
      );
      
      if (response.status === 200) {
        let data = response.data;
        storage.saveLocalStorage(
          "token",
          //response.data.DbResponse.Result.Token
          data.data.accesstoken
        );
        storage.saveLocalStorage("refreshToken", data.data.refreshtoken);
        //localStorage.setItem("token", response.data.token);
        //return response.data.DbResponse.Result.Data;
        return data;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error : any) {
      const errorData = error.response?.data;
      const errorMessage = errorData?.error || errorData?.message || 'Login failed';
      throw new Error(errorMessage);
    }
  },
  getUserModulePriviliges: async () => {
    try {
      const response = await axiosInstance.get(
        "/authorization/api/User/GetUserModulePrivileges"
      );
      if (response.status === 200) {
        //return response.data;
        return response.data;
      } else {
        //console.log("Auth service error!", response);
        throw new Error(response.data.message);
      }
    } catch (error: any) {
      throw new Error("Error in getUserModulePriviliges");
    }
  },
  getUserOtherPrivilegesDetails: async (requestData: any) => {
    try {
      const response = await axiosInstance.post(
        "/authorization/api/User/GetUserOtherPrivilegesDetails",
        requestData
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error: any) {
      throw new Error(error.response?.data?.message || "Error fetching other privileges");
    }
  },
  getOfficeList: async () => {
    try {
      const response = await axiosInstance.get(
        "/auth/api/HrOffice"
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error: any) {
      throw new Error(error.response?.data?.message || "Error fetching office list");
    }
  },
  checkUserBranches: async (usernames: string[]) => {
    try {
      const response = await axiosInstance.post(
        "/authorization/api/User/CheckUserBranches",
        { usernames }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error: any) {
      throw new Error(error.response?.data?.message || "Error checking user branches");
    }
  },
};

export default authService;
